<span>{{ currency }}</span>
